// The analytics consent choice, in one cookie on the apex so every app reads the same answer.

export type ConsentChoice = 'granted' | 'denied';

export const CONSENT_STORAGE_KEY = 'iv_cookie_consent';

const DAY = 60 * 60 * 24;
// Remember an opt-in far longer than an opt-out, so deniers are re-asked sooner.
const MAX_AGE: Record<ConsentChoice, number> = {
  granted: DAY * 180,
  denied: DAY * 14,
};

/** The two-label apex (izivote.com), or null for a host-only cookie on localhost, IPs and single labels. */
export function consentCookieDomain(
  hostname: string = typeof location !== 'undefined' ? location.hostname : ''
): string | null {
  if (!hostname || hostname === 'localhost' || /^[\d.]+$/.test(hostname) || !hostname.includes('.')) {
    return null;
  }
  return hostname.split('.').slice(-2).join('.');
}

export function readConsentChoice(): ConsentChoice | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${CONSENT_STORAGE_KEY}=(granted|denied)`));
  return match ? (match[1] as ConsentChoice) : null;
}

export function persistConsentChoice(choice: ConsentChoice): void {
  if (typeof document === 'undefined') return;
  const cookieDomain = consentCookieDomain();
  const domainAttr = cookieDomain ? `; Domain=.${cookieDomain}` : '';
  document.cookie = `${CONSENT_STORAGE_KEY}=${choice}; path=/; max-age=${MAX_AGE[choice]}; SameSite=Lax${domainAttr}`;
}
